import { Arabic } from "./ar";
import { English } from "./en";

export const Translate = {
    ar: Arabic,
    en: English
}